


































helpers = require('../../helpers.coffee')
usersResource = new UsersResource

view_model =
  data: ->
    apiErrorMessages: []
    token: ''
    user:
      password: ''
      password_confirmation: ''

  methods:
    extractTokenIfExists: ->
      @token = @$route.query && @$route.query.hasOwnProperty('token') && @$route.query.token

    redirectIfNoToken: ->
      if (!@token)
        @$router.push(name: 'landing')

    submit: ->
      @$validator.validateAll().then (success) =>
        @resetPassword() if success

    resetPassword: ->
      Loader.on()
      params = Object.assign({reset_password_token: @token}, @user)
      usersResource.resetPassword(@resetPasswordSuccess, @resetPasswordFailure, params)

    resetPasswordSuccess: (response) ->
      Loader.off()
      Session.signIn(response.body.user)
      @$router.push(name: 'flows')

    resetPasswordFailure: (response) ->
      Loader.off()
      @handleApiErrors(response, extra_attributes: ['reset_password_token'])

  created: ->
    @extractTokenIfExists()
    @redirectIfNoToken()

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/sessions/reset_password.vue